<template>
  <div class="data-list">
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            label-width="110px"
            size="mini"
          >
            <el-form-item label="文件名称" prop="id">
              <el-input
                v-model="searchForm.id"
                clearable
                type="number"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="操作人" prop="name">
              <el-input
                v-model="searchForm.name"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
           
            <el-form-item label="状态" prop="status">
              <el-select v-model="searchForm.status" clearable @change="onSearch">
                <el-option v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="导入时间">
              <q-date-picker v-model="searchForm" ref="dateRef" />
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">
              查询
            </el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="downloadTemp">
            模版下载
          </el-button>
          <el-button type="primary" size="small" @click="uploadFiles">
            上传解密
          </el-button>
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          highlight-current-row
          border
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column  prop="id" label="文件名称" align="center"></el-table-column>
          <el-table-column  prop="createdBy" label="操作人" align="center" ></el-table-column>
          <el-table-column  prop="status" label="状态" align="center"></el-table-column>
          <el-table-column  prop="createdTime" label="导入时间" align="center"></el-table-column>
          <el-table-column  label="操作"  class-name="action-column" align="center">
            <template slot-scope="scope">
              <template v-if="scope.row.status == '成功'">
                <el-button type="text" size="small" @click="download(scope.row.downloadUrl,`解密数据${scope.row.id}`)">解密下载</el-button>
              </template>
              <el-button type="text" size="small" @click="download(scope.row.sourceDownloadUrl,`源文件数据${scope.row.id}`)">源文件下载</el-button>
            </template>
          </el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
    <import-dialog v-if="isShowImport" :visible.sync="isShowImport" reportName="importDecryptionPhone"></import-dialog>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import importDialog from '@/views/import-export/import-dialog'
import { downloadFile } from '@/utils/downloadFile.js'
export default {
  name: "dataDecode",
  mixins: [tableMixin],
  components: {
    importDialog
  },
  data() {
    return {
      searchForm: {
        id: '',
        name: "",
        status: "",
        startTime: "",
        endTime: "",
      },
      statusOptions: [ 
        {value: '', label: '全部'},
        {value: 1, label: '解密中'},
        {value: 2, label: '成功'},
        {value: 3, label: '失败'},
      ],
      // 表格相关
      tableData: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      isShowImport: false
    };
  },
  methods: {
    init() {
      this.onSearch();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.configure
        .decryptionRecordPageList(params)
          .then(({ data: { list, total } }) => {
            this.tableData = list || [];
            this.total = total;
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.initDate()
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    initDate() {
      this.searchForm.startTime = ''
      this.searchForm.endTime = ''
      this.$refs.dateRef.reset()
    },
    download (url,fileName) {
      downloadFile(url,fileName)
    },
    downloadTemp() {
      // https://tactivity.quanyou.com.cn/group1/M00/0E/6E/rB8kQmRkb2uAAzPeAABmAPUEoOY473.xls 
       this.$api.common.downloadTemplate('importDecryptionPhone').then(res => {
        if (res.success) {
          downloadFile(res.data.templatePath,'模版数据')
        }
      })
    },
    uploadFiles() {
      this.isShowImport = true
    }
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.date-input
  width 220px !important
</style>
